import React, { useState } from "react";
import AddCharge from "../AddEdit/AddCharge";

const ProfitLossTab = () => {
  const [showAdd, setShowAdd] = useState(false);
  const handleCloseAdd = () => setShowAdd(false);
  const handleShowAdd = () => setShowAdd(true);
  return (
    <>
      <div className="row border-bottom-2 pb-3">
        <div className="col-md-12">
          <div className="card px-3 py-2">
          <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                            
                        </div>
                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                            <div className="btn btn-primary cursor-pointer me-2">
                                Export Excel
                            </div>
                            <div className="btn btn-primary cursor-pointer me-2">
                                Print
                            </div>
                            <div className="btn btn-primary cursor-pointer me-2">
                                Single Job Profitability
                            </div>
                        </div>
                    </div>
            <div className="row">
            <div className="table-responsive ">
              <table className="table table-striped table-sm">
                <thead>
                  <tr className="header-group">
                    <th colspan="1"> </th>
                    <th colspan="2">Revenue</th>
                    <th colspan="2">Cost</th>
                    <th colspan="4">Margin</th>
                  </tr>
                  <tr>
                    <th scope="col">Charge</th>
                    <th scope="col">Estimated</th>
                    <th scope="col">Billed</th>
                    <th scope="col">Estimated</th>
                    <th scope="col">Booked</th>
                    <th scope="col">Estimated</th>
                    <th scope="col">(%)</th>
                    <th scope="col">Actual</th>
                    <th scope="col">(%)</th>
                  </tr>
                </thead>
                <tbody>
                  {/* <tr>
                    <td>1</td>
                    <td>Tax</td>
                    <td>4114.00</td>
                    <td>456.00</td>
                    <td>3658.00</td>
                    <td>88.92%</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Incentive Payables</td>
                    <td>0.00</td>
                    <td>20843.00</td>
                    <td></td>
                    <td></td>
                  </tr> */}
                </tbody>
              </table>
            </div>
            </div>
          </div>
        </div>
      </div>

      {/* <AddCharge showAdd={showAdd} handleCloseAdd={handleCloseAdd} /> */}
      {/* <EditCargoDlts showAdd={showEdit} handleCloseAdd={handleCloseEdit} /> */}
    </>
  );
};

export default ProfitLossTab;
